import { resolveLabelFontSize } from '../../TextInput/TextInputStyles';
export const exclamationCircleIconDefaultStyle = (theme, size) => ({
  color: theme.tokens.ComponentTextInputErrorColor,
  fontSize: resolveLabelFontSize(theme, size)
});
export const checkCircleIconDefaultStyle = (theme, size) => ({
  color: theme.tokens.ComponentTextInputBorderSuccessColor,
  fontSize: resolveLabelFontSize(theme, size)
});
export const warningRoundedIconDefaultStyle = theme => ({
  color: theme.tokens.ComponentTextInputWarningColor,
  margin: '0 4px 0 -4px',
  height: '20px',
  width: '20px'
});